import { Component, OnDestroy, OnInit } from '@angular/core';
import { pdaConfiguration } from '../../utils/pda-configuration';
import { ConfigurationService } from 'src/app/common/configuration/services/configuration.service';
import { PdaAcceptanceInfos, PdaAccessToken, PdaAuthService, PdaSaveTokenRequest } from '../../utils/Service/pda-auth.service';
import { DialogService } from 'src/app/core/components/dialog/dialog.service';
import { PdaDisclaimerComponent } from '../pda-disclaimer/pda-disclaimer.component';
import { ConfirmModalComponent } from 'src/app/core/components/dialog/components/confirm-modal/confirm-modal.component';
import { PdaPlaceholders } from '../../utils/placeholder';
import { NomiDescrittoriSezione } from 'src/app/common/configuration/nomi-descrittori-sezione';


@Component({
  selector: 'app-pda-login-icon',
  templateUrl: './pda-login-icon.component.html',
  styleUrls: ['./pda-login-icon.component.css']
})
export class PdaLoginIconComponent implements OnInit, OnDestroy {
  isActive = false;
  tooltip: string = "Connettiti a PDA";

  constructor(
    private config: ConfigurationService,
    private auth: PdaAuthService,
    private dialog: DialogService,
  ) {
    this.auth.logout.subscribe(
      (logout:boolean) => {
        if(logout === true) {
          this.deleteToken();
        }
      }
    )
    this.auth.isLogged.subscribe(
      (logged:boolean) => {
        if(logged) this.onLoggedTrue(); else this.onLoggedFalse();
      }
    )
  }


  ngOnInit() {}

  onLoggedTrue(){
    this.isActive = true;
    pdaConfiguration.forEach(x => x.enabled = true);
  }

  onLoggedFalse(){
    this.isActive = false;
    pdaConfiguration.forEach(x => {
      if (x.context !== "USER" && x.context !== NomiDescrittoriSezione.DESCRITTORE_CANCELLERIA_TELEMATICA) x.enabled = false;
    });
  }

  connectToPda(): void {
    this.isActive ? this.logout() : this.loginToPda();
  }

  private loginToPda(): void {
    this.auth.loginToPda().subscribe(
      (token) => {
        if (token) {
          this.showDisclaimerModal(token);
        }
      }
    );
  }

  private showDisclaimerModal(token) {
    const ref = this.dialog.open(PdaDisclaimerComponent, {
      data: {
        style: {
          width: '30%',
        },
        title: 'Accesso al portale PDA',
      }
    });
    ref.afterClosed.subscribe(async event => {
      if(!event || event.closeEvent) return;
      if(event.modalEvent === true) {
        let pdaAcceptanceInfos = {acceptanceFlag: true, acceptanceTimestamp: Date.now()};
        this.saveToken(token, pdaAcceptanceInfos);
      } else {
        let pdaAcceptanceInfos = {acceptanceFlag: false, acceptanceTimestamp: Date.now()};
        this.setToken(token,pdaAcceptanceInfos);
      }
    });
  }

  private saveToken(token: any, pdaAcceptanceInfos: PdaAcceptanceInfos) {
    let tokenToSave: PdaSaveTokenRequest = {
      type: token.type,
      user: token.user,
      passwd: token.passwd,
      expiresIn: token.expiresIn,
      refreshToken: token.refreshToken,
      refreshTokenExpiresIn: token.refreshTokenExpiresIn,
      acceptanceFlag: pdaAcceptanceInfos.acceptanceFlag,
      acceptanceTimestamp: pdaAcceptanceInfos.acceptanceTimestamp
    };
    this.auth.saveUserToken(tokenToSave).subscribe(
      (savedtoken: PdaAccessToken) => {
        this.setToken(savedtoken, pdaAcceptanceInfos);
      }
    );
  }

  private async setToken(token: PdaAccessToken, infos: PdaAcceptanceInfos){
    await this.auth.setPdaToken(token);
    await this.auth.setPdaInfos(infos);
    this.auth.onLogoutUserPda(false);
    this.auth.setIsLogged(true);
  }


  private logout(): void {
    const ref = this.dialog.open(ConfirmModalComponent, {
      data: {
        modalConfirm: {
          text: 'Sei sicuro di voler abbandonare la connessione a PDA ?',
          data: [],
        },
        style: {
          width: '30%',
        },
        title: 'Disconnessione da PDA',
      }
    })
    ref.afterClosed.subscribe(event => {
      if(!event || event.closeEvent) return;
      if(event && event.modalEvent === true) {
        this.auth.setIsLogged(false);
        this.deleteToken();
      }
    });
  }

  async deleteToken() {
    let pdaAcceptanceInfos = await this.auth.getPdaInfos();
    if(pdaAcceptanceInfos && pdaAcceptanceInfos.acceptanceFlag){
      this.auth.deleteUserToken().subscribe(
        () => {

          this.clearToken();
        }
      );
    }
    else{
      this.clearToken();
    }
  }

  async clearToken(){
    await this.auth.removePdaToken();
    await this.auth.removePdaInfos();
    this.auth.onLogoutUserPda(false);
    this.auth.setIsLogged(false);
  }

  ngOnDestroy(): void {

  }

}
